<template>
    <div class="text-center py-40">
        <h1 class="text-8xl font-bold text-gray-800">404</h1>
        <h1 class="text-2xl font-bold text-gray-800">Page Not Found</h1>
        <p class="mt-4 text-gray-500">Sorry, the page you are looking for does not exist.</p>
    </div>
</template>

<script>
export default {
    name: 'NotFound'
};
</script>

<style scoped></style>